import { createSlice } from "@reduxjs/toolkit";

export type SettingsState = {
  error: any;
  loading: boolean;
  menuCollapsed: boolean;
};

const initialState: SettingsState = {
  error: false,
  loading: false,
  menuCollapsed: true,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.menuCollapsed = !state.menuCollapsed;
    },
  },
});

//selectors

export const { toggleMenu } = settingsSlice.actions;
export default settingsSlice.reducer;
